// extracted by mini-css-extract-plugin
export var resultDetails = "adress-search-results-module--result-details--3fdbb";
export var resultItem = "adress-search-results-module--result-item--58c2e";
export var resultItemTaxo = "adress-search-results-module--result-item-taxo--cbf50";
export var resultItemTaxoContainer = "adress-search-results-module--result-item-taxo-container--9c7ef";
export var resultMore = "adress-search-results-module--result-more--eb40e";
export var resultTitle = "adress-search-results-module--result-title--01b68";
export var resultTitleNotClickable = "adress-search-results-module--result-title-not-clickable--9e214";
export var resultTop = "adress-search-results-module--result-top--f0ad0";
export var results = "adress-search-results-module--results--74721";
export var resultsContainer = "adress-search-results-module--results-container--6a9a2";